<ng-content select="glxy-empty-state-hero, [glxyEmptyStateHero]" />
<div class="glxy-empty-state__content">
  <ng-content select="glxy-empty-state-title, [glxyEmptyStateTitle]" />
  <ng-content />
</div>
<ng-content select="glxy-empty-state-actions, [glxyEmptyStateActions]" />
<ng-content select="glxy-empty-state-footnote, [glxyEmptyStateFootnote]" />
